import { AppAreaConfig } from '@/funnels/@types'
import femalePr from './female-pr'
import malePr from './male-pr'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-pr',
	landing: {
		ids: ['loader-main'],
		route: {
			path: '/pr',
			name: 'main-pr-funnel',
		},
	},
	funnel: {
		id: 'ob-universal-pr-funnel',
		route: {
			path: '/pr/ob/:page(.*)?',
			name: 'main-pr',
		},
		slug: 'main-pr',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			sex: {
				male: { appArea: malePr },
				female: { appArea: femalePr },
			},
		},
	},
}

export default appAreaConfig
